import { useEffect } from 'react';
import { mainButton } from '@tma.js/sdk-react';
import { isInTelegram } from '../telegram';

interface MainButtonProps {
    text: string;
    onClick: () => void;
    visible?: boolean;
    loading?: boolean;
}

export function MainButton({ text, onClick, visible = true, loading = false }: MainButtonProps) {
    useEffect(() => {
        if (!isInTelegram()) return;

        if (visible) {
            mainButton.setParams({
                text,
                isVisible: true,
                isLoaderVisible: loading
            });
            const off = mainButton.onClick(onClick);
            return () => {
                off();
                mainButton.hide();
            };
        } else {
            mainButton.hide();
        }
    }, [text, onClick, visible, loading]);

    return null;
}
